export const getFriendlyDate = (date: string, short?: boolean): string => {
   // if short only month and year
   if (short) {
      return new Date(date).toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
   }

   return new Date(date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const getTimeAgo = (date: Date): string => {
   const now = new Date();
   const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

   const intervals = [
      { label: 'year', seconds: 31_536_000 },
      { label: 'month', seconds: 2_592_000 },
      { label: 'week', seconds: 604_800 },
      { label: 'day', seconds: 86_400 },
      { label: 'hour', seconds: 3_600 },
      { label: 'minute', seconds: 60 },
   ];

   for (const interval of intervals) {
      const count = Math.floor(seconds / interval.seconds);
      if (count >= 1) {
         return `${count} ${interval.label}${count !== 1 ? 's' : ''} ago`;
      }
   }
   return 'just now';
};

export const getTimeUntil = (date: Date): string | null => {
   // returns null if the date is in the past
   const now = new Date();
   const seconds = Math.floor((date.getTime() - now.getTime()) / 1000);

   const intervals = [
      { label: 'year', seconds: 31_536_000 },
      { label: 'month', seconds: 2_592_000 },
      { label: 'week', seconds: 604_800 },
      { label: 'day', seconds: 86_400 },
      { label: 'hr', seconds: 3_600 },
      { label: 'min', seconds: 60 },
   ];

   for (const interval of intervals) {
      const count = Math.floor(seconds / interval.seconds);
      if (count >= 1) {
         return `${count} ${interval.label}${count !== 1 ? 's' : ''}`;
      }
   }
   return null;
};
